import { msg } from '@lingui/core/macro';
import { NotificationType } from 'modules/core/domain/interfaces/supabase/notifications/types';
import type { MessageDescriptor } from 'shared/i18n';

export const NOTIFICATION_TYPE_LABELS: Record<NotificationType, MessageDescriptor> = {
  update: msg`Обновление`,
  bugfix: msg`Исправление ошибок`,
  maintenance: msg`Техническое обслуживание`,
  info: msg`Информация`,
  upcoming: msg`Предстоящее обновление`,
  known_issue: msg`Известная проблема`,
  user_event: msg`Личные события`,
};
